import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center bg-white/80 dark:bg-gray-900/80 backdrop-blur-sm"
}
const _hoisted_2 = { class: "flex flex-col items-center space-y-6 px-4" }
const _hoisted_3 = { class: "text-center space-y-3" }
const _hoisted_4 = { class: "text-lg font-semibold text-gray-900 dark:text-white" }

import { computed } from 'vue'
import { useLoadingStore } from '@/stores/loading'

// Store

export default /*@__PURE__*/_defineComponent({
  __name: 'PageLoader',
  setup(__props) {

const loadingStore = useLoadingStore()

// Computed Properties
const isPageLoading = computed(() => loadingStore.isPageLoading)
const loadingText = computed(() => loadingStore.loadingText)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (isPageLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "relative w-16 h-16" }, [
                _createElementVNode("div", { class: "absolute inset-0 rounded-full spinner-ring" })
              ], -1)),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h3", _hoisted_4, _toDisplayString(loadingText.value), 1),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "w-64 h-1 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden" }, [
                  _createElementVNode("div", { class: "h-full rounded-full animate-loading-bar progress-gradient" })
                ], -1)),
                _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-sm text-gray-500 dark:text-gray-400" }, " Please wait... ", -1))
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})